


















import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class Task extends Vue {
  @Prop({ default: false })
  readonly completed!: boolean;
}
